import React from "react";
import Page from "./page";

export default function Index({ texto: Texto }) {
  return (
    <Page texto={Texto} />
  );
}